import React from 'react'
import PropTypes from 'prop-types'
import {countPercent} from './'

const propTypes = {
  inspectionCategoryTypes: PropTypes.array.isRequired,
  inspectionsData: PropTypes.object.isRequired
}

const InspectionTableData = ({inspectionCategoryTypes, inspectionsData}) => {
  return (
    <React.Fragment>
      {inspectionCategoryTypes.map(inspCatType =>
        <React.Fragment key={inspCatType.id}>
          <td>{inspectionsData[inspCatType.id] ? `${inspectionsData[inspCatType.id]['complete']}` : ''}</td>
          <td>{inspectionsData[inspCatType.id] ? `${inspectionsData[inspCatType.id]['failed']}` : ''}</td>
          <td>{inspectionsData[inspCatType.id] &&
          countPercent(inspectionsData[inspCatType.id]['complete'], inspectionsData[inspCatType.id]['failed'])}</td>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

InspectionTableData.propTypes = propTypes

export default InspectionTableData



// WEBPACK FOOTER //
// ./src/components/Report/defectivness/InspectionTableData.js